// extracted by mini-css-extract-plugin
export var numpadContainer = "_so-1";
export var phoneButton = "_so-0";